import React, {FC} from "react"

import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {Body, H6, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import FormattedMessage from "@irati/utils/lang"
import {User} from "@irati/types"

interface Props {
  user: User
  text: string
  value: number
}

const RecognitionUser: FC<Props> = ({user, text, value}) => {
  return (
    <Flex gap={1}>
      <ProfilePicture user={user} size={25} />
      <div>
        <H6 display="inline">{firstnameLastname(user)}:</H6>
        <Label marginLeft={0.5}>
          <FormattedMessage id={text} />
        </Label>
        <Body small>
          <FormattedMessage id="admin.components.dashboard.reporting.recognition.recognitionUser" values={{value}} />
        </Body>
      </div>
    </Flex>
  )
}

export default RecognitionUser
